/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { EmojiData, EmojiPicker } from '../../../ui/emoji';
import { useResolve } from '../../Container';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export const ReactionWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);

    const onSelect = useCallback((e: EmojiData) => {
        widget.update({ open: false });

        tools.setSetting('reactionTool', 'value', e.id);
        dispatch(toolEquip, ['reactionTool']);

    }, [widget]);

    return <Flexer className="consumeWheel" relative>
        <EmojiPicker onSelect={onSelect} />
    </Flexer>;
});
